import { CollectionProps } from 'app/components/Core/convention'
import PriceInfoItem from 'app/components/Core/LineItem/Price/InfoItem'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { sumBy } from 'lodash'
import React from 'react'

type Props = {
  memberProps?: Partial<ILineItem>
  // Either by total for items with unit and quantity or by discountedUnitPrice for items
  sumBy?: 'total' | 'discountedUnitPrice'
}

const LineItemTotalCost: React.FC<
  CollectionProps<Pick<ILineItem, 'name' | 'discountedUnitPrice' | 'total'>, Props>
> = ({ collection, props: { memberProps, sumBy: sumByKey = 'total' } = {} }) => {
  const { tRecordType } = ToolBox.useString()

  return (
    <PriceInfoItem
      member={{
        name: tRecordType(RecordType.line_item, 'total_cost'),
        discountedUnitPrice: sumBy(collection, sumByKey),
        ...memberProps
      }}
    />
  )
}

export default LineItemTotalCost
